import { createSlice } from "@reduxjs/toolkit";
import {
  CALENDAR_LANG,
  CALENDAR_TYPE,
  APP_LOCALIZATION,
  USER_DETAILS,
  PAID_AMOUNT,
  PERMISSIONS,
  JOURNAL_VIEW_TYPE,
} from "Shared/Tokens";

const savedCalendarType = localStorage.getItem(CALENDAR_TYPE);
const savedCalendarLang = localStorage.getItem(CALENDAR_LANG);
const savedPaidAmount = localStorage.getItem(PAID_AMOUNT);
const savedAppLocalization = localStorage.getItem(APP_LOCALIZATION);
const savedUserDetails = localStorage.getItem(USER_DETAILS);
const savedPermissions = localStorage.getItem(PERMISSIONS);
const journalviewtype = localStorage.getItem(JOURNAL_VIEW_TYPE);

const appDataSlice = createSlice({
  name: "appData",
  initialState: {
    calendarType: savedCalendarType ?? "en",
    calendarLang: savedCalendarLang ?? "en",
    paidAmount: savedPaidAmount ?? "a",
    appLocalization: savedAppLocalization ?? "en",
    userDetails: savedUserDetails ?? null,
    permissions: savedPermissions ?? [],
    journalviewtype: journalviewtype ?? "ledger",
  },
  reducers: {
    toggleAppData: (state, action) => {
      if (action.payload.calendarType) {
        state.calendarType = action.payload.calendarType;
        localStorage.setItem(CALENDAR_TYPE, action.payload.calendarType);
      }
      if (action.payload.calendarLang) {
        state.calendarLang = action.payload.calendarLang;
        localStorage.setItem(CALENDAR_LANG, action.payload.calendarLang);
      }
      if (action.payload.paidAmount) {
        state.paidAmount = action.payload.paidAmount;
        localStorage.setItem(PAID_AMOUNT, action.payload.paidAmount);
      }
      if (action.payload.appLocalization) {
        state.appLocalization = action.payload.appLocalization;
        localStorage.setItem(APP_LOCALIZATION, action.payload.appLocalization);
      }
      if (action.payload.userDetails) {
        state.userDetails = action.payload.userDetails;
        localStorage.setItem(USER_DETAILS, action.payload.userDetails);
      }
      if (action.payload.permissions) {
        state.permissions = action.payload.permissions;
        localStorage.setItem(PERMISSIONS, action.payload.permissions);
      }
      if (action.payload.journalviewtype) {
        state.journalviewtype = action.payload.journalviewtype;
        localStorage.setItem(JOURNAL_VIEW_TYPE, action.payload.journalviewtype);
      }
    },
  },
});

export const { toggleAppData } = appDataSlice.actions;
export default appDataSlice.reducer;
